import { Quote } from '../types';

interface QuoteSummaryProps {
  quote: Quote;
}

const QuoteSummary = ({ quote }: QuoteSummaryProps) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const implementationSubtotal = quote.implementation.items.reduce(
    (sum, item) => sum + item.unitPrice * item.quantity,
    0
  );

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-6">
      <h2 className="text-lg font-semibold text-text-primary mb-4">Quote Summary</h2>

      <div className="space-y-3">
        {quote.licenses.included && (
          <>
            <div className="flex justify-between items-center py-2">
              <span className="text-sm text-text-secondary">Software licenses Monthly</span>
              <span className="text-sm font-medium text-text-primary font-mono">
                {formatCurrency(quote.licenses.monthlySubtotal)}
              </span>
            </div>
            <div className="flex justify-between items-center py-2">
              <span className="text-sm text-text-secondary">Software licenses Annual</span>
              <span className="text-sm font-medium text-text-primary font-mono">
                {formatCurrency(quote.licenses.annualSubtotal)}
              </span>
            </div>
          </>
        )}

        {quote.implementation.included && (
          <>
            <div className="flex justify-between items-center py-2">
              <span className="text-sm text-text-secondary">Implementation Services</span>
              <span className="text-sm font-medium text-text-primary font-mono">
                {formatCurrency(implementationSubtotal)}
              </span>
            </div>
            {quote.onDemandTotal > 0 && (
              <div className="flex justify-between items-center py-2">
                <span className="text-sm text-text-secondary">On demand services (estimate for meetings, quality assurance, ...)</span>
                <span className="text-sm font-medium text-text-primary font-mono">
                  {formatCurrency(quote.onDemandTotal)}
                </span>
              </div>
            )}
            {quote.projectMgmtTotal > 0 && (
              <div className="flex justify-between items-center py-2">
                <span className="text-sm text-text-secondary">Project Overhead 15%</span>
                <span className="text-sm font-medium text-text-primary font-mono">
                  {formatCurrency(quote.projectMgmtTotal)}
                </span>
              </div>
            )}
          </>
        )}

        <div className="border-t border-border pt-3 mt-3">
          <p className="text-xs text-text-secondary">
            Amounts excluding VAT. Implementation Services are estimates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default QuoteSummary;